import "./panchangam.css";
import PanchangamSVT from "./PanchangamSVT";
import PanchangamDt from "./PanchangamDT";
import templeJson from "../../../../config/temple.json";

function Panchang(props) {
  // console.log("props : ", props);
  return (
    <>
      {templeJson["Panchangam"].style === 1 ? (
        <PanchangamDt />
      ) : (
        <PanchangamSVT dailyPanchang={props?.dailyPanchang} />
      )}
    </>
  );
}
export default Panchang;
